/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `maintenance` - Maintenance
 * * `modernization` - Modernization
 * * `callback` - Callback
 * * `inspection` - Inspection
 * * `repair` - Repair
 * * `fee` - Late Fee / Service Fee
 */
export type InvoiceTypeEnum = typeof InvoiceTypeEnum[keyof typeof InvoiceTypeEnum];


export const InvoiceTypeEnum = {
  maintenance: 'maintenance',
  modernization: 'modernization',
  callback: 'callback',
  inspection: 'inspection',
  repair: 'repair',
  fee: 'fee',
} as const;
